import { required } from 'vuelidate/lib/validators'
import {
  slugValidator,
  slugAsyncValidator,
  validationErrorMessages
} from '@/utils/validations/validations'
import routesSlugsQuery from '@/services/gql/types/Routes/queries/routesSlugs.gql'

export default ({ id, ctx, isNew }) => {
  const isUnique = async value => {
    return await slugAsyncValidator(value, id, routesSlugsQuery, ctx, 'routes')
      .then(res => res)
      .catch(err => console.log(err))
  }
  return {
    title: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    slug: (() => {
      if (isNew) {
        return false
      }
      return {
        required: { validator: required, message: validationErrorMessages.required },
        generalValidation: {
          validator: slugValidator,
          message: validationErrorMessages.slugGeneralMsg
        },
        isUnique: { validator: isUnique, message: validationErrorMessages.unique }
      }
    })(),
    profileType: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    profileId: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    modes: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    categories: {
      required: { validator: required, message: validationErrorMessages.required }
    },
    description: {
      required: { validator: required, message: validationErrorMessages.required }
    }
  }
}
